var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"Markdown",class:{ hasStyles: _vm.hasStyles },domProps:{"innerHTML":_vm._s(_vm.markdownSanitized)}},'div',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }